/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ModalHeader } from "reactstrap";
import { addMailForm, editMailForm } from "../../apis/admin/newsletter";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { toast } from "../../utils/toast";
import Form from "../Form";
import Modal from "../Modal";
import { isEmpty } from "../../utils/lodashExtend";
import { cloneDeep } from "lodash";
import { isAdmin } from "../../utils/auth";

const defaultForm = {
  title: "",
  content: "",
  isHide: "false",
  type: "YDS",
  footerType: "text"
};

const mailFormSetLogo = (convert) => {
  return `
  <table
  style="
    width: 100%;
    max-width: 650px;
    height: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    border-spacing: 0;
  "
>
  <tbody style="border: 0; margin: 0">
    <tr style="border: 0; margin: 0">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
          padding-top: 1em;
        "
      >
        ${convert.companyLogo}
      </td>
    </tr>
    <tr style="border: 0; margin: 0">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
        "
      >
        <span
          style="
            color: #000;
            font-size: 15px;
            font-weight: bold;
            width: 200px;
            text-align: right;
            display: block;
          "
        >
          ${convert.ceoName}
        </span>
      </td>
    </tr>
    <tr style="border: 0; margin: 0; height: 20%">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          width: 30%;
          padding-top: 2em;
        "
      >
        <table
          style="
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            border: 0;
            border-spacing: 0;
          "
        >
          <tbody style="border: 0; margin: 0">
            <tr style="border: 0; margin: 0">
              <td
                style="
                  margin: 0;
                  padding: 0;
                  border: 0;
                  padding-left: 1.5em;
                "
              >
                ${convert.homePage} ${convert.blog} ${convert.youtube} ${convert.instagram}
              </td>
            </tr>
          </tbody>
        </table>
      </td>
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          width: 50%;
        "
      ></td>
    </tr>
    <tr style="border: 0; margin: 0; height: 20%">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
          padding-top: 1em;
          vertical-align: middle;
        "
      >
        <!--mail form--><a
          target="_blank"
          href="https://yds.ai/unsubscribe/?email=feelsky665@naver.com"
          ><img
            src="https://smileceo-files.s3.ap-northeast-2.amazonaws.com/ab556f30-efb7-11ed-8350-7f20f5b35c5ab1560aad-d6ec-4ba1-a44b-2a331dd5d562.png"
        /></a>
      </td>
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          float: right;
          padding-top: 1em;
          padding-right: 1em;
        "
      >
        <img
          src="https://smileceo-files.s3.ap-northeast-2.amazonaws.com/5ea77a00-35b9-11ee-ace2-5fe6ef61607122d368ad-3b4e-401e-a796-2e40d168ea72.png"
          style="height: 12px"
        />
      </td>
    </tr>
  </tbody>
</table>`;
};

const mailFormSetText = (convert) => {
  return `<table
  style="
    width: 100%;
    max-width: 650px;
    height: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    border-spacing: 0;
  "
>
  <tbody style="border: 0; margin: 0">
    <tr style="border: 0; margin: 0">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
          padding-top: 1em;
        "
        colspan="2"
      >
        <span style="font-size: 24px; font-weight: bold"
          >${convert.companyName}</span
        >
      </td>
    </tr>
    <tr style="border: 0; margin: 0">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
        "
        colspan="2"
      >
        <span
          style="
            color: #000;
            font-size: 12px;
            font-weight: bold;
          "
        >${convert.ceoName}</span>
      </td>
    </tr>
    <tr style="border: 0; margin: 0; height: 20%">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
          padding-top: 1em;
        "
      >
        <span style="font-size: 13px; color: #000"
          >${convert.tel}</span
        >
      </td>
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          width: 50%;
        "
      ></td>
    </tr>
    <tr style="border: 0; margin: 0; height: 20%">
      <td
        style="
          margin: 0;
          padding: 0 50px 0 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
        "
        colspan="2"
      >
        <span style="font-size: 12px; color: #000"
          >${convert.address}</span
        >
      </td>
    </tr>
    <tr style="border: 0; margin: 0; height: 20%">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
        "
      >
        <span style="font-size: 12px; color: #000">${convert.fax}</span>
      </td>
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          width: 50%;
          float: right;
          padding-right: 1.5em;
        "
      >
        <table
          style="
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
            border: 0;
            border-spacing: 0;
          "
        >
          <tbody style="border: 0; margin: 0">
            <tr style="border: 0; margin: 0">
              <td
                style="
                  margin: 0;
                  padding: 0;
                  border: 0;
                  padding-left: 1.5em;
                "
              >
                ${convert.homePage} ${convert.blog} ${convert.youtube} ${convert.instagram}
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr style="border: 0; margin: 0; height: 20%">
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          padding-left: 1.5em;
          padding-top: 1em;
          vertical-align: middle;
        "
      >
        <!--mail form--><a
          target="_blank"
          href="https://yds.ai/unsubscribe/?email=feelsky665@naver.com"
          ><img
            src="https://smileceo-files.s3.ap-northeast-2.amazonaws.com/ab556f30-efb7-11ed-8350-7f20f5b35c5ab1560aad-d6ec-4ba1-a44b-2a331dd5d562.png"
        /></a>
      </td>
      <td
        style="
          margin: 0;
          padding: 0;
          border: 0;
          float: right;
          padding-top: 1em;
          padding-right: 1em;
        "
      >
        <img
          src="https://smileceo-files.s3.ap-northeast-2.amazonaws.com/5ea77a00-35b9-11ee-ace2-5fe6ef61607122d368ad-3b4e-401e-a796-2e40d168ea72.png"
          style="height: 12px"
        />
      </td>
    </tr>
  </tbody>
</table>`;
};

const MailForm = (props) => {
  const { selectedItem, setSelectedItem, open, setOpen, submit, type = "YDS", convertData = {} } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState("create");
  const [content, setContent] = useState();
  const [footerType] = useState("text");
  // const [footer, setFooter] = useState();

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  const _submit = (form) => {
    let body = {
      ...form,
      content: (form.content || "").replace(/\n/g, "<br/>"),
      footer: (form.footer || "").replace(/\n/g, "<br/>"),
    };
    if (mode === "modify") {
      delete body.content;
      systemAlert(`"${form.title}"메일폼 정보를 수정하시겠습니까?`, {
        buttons: [
          {
            color: "text",
            label: "취소"
          },
          {
            label: "수정",
            onClick: () => {
              editMailForm(form.idx, body)
                .then(res => {
                  toast.success("수정되었습니다.");
                  cancel();
                  submit && submit();
                }).catch((err) => {
                  console.error(err.response);
                });
            }
          }
        ]
      });

    } else {
      addMailForm(body).then(() => {
        toast.success("등록되었습니다.");
        cancel();
        submit && submit();
      }).catch((err) => {
        console.error(err.response);
      });
    }
  };



  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    originForm,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setFields([
      {
        title: "제목",
        key: "title",
        type: "input",
        required: true,
        readOnly: type === "PARTNER",
      },
      [
        {
          isHide: type === "PARTNER",
          title: "목록 노출 여부",
          key: "isHide",
          type: "radio",
          options: {
            list: [{ label: "노출", value: "false" }, { label: "숨김", value: "true" }]
          },
        },
        {
          title: "구분",
          key: "type",
          type: "radio",
          options: {
            list: [{ label: "YDS", value: "YDS" }, { label: "PARTNER", value: "PARTNER" }]
          },
          isHide: type === "PARTNER",
        },
      ],
      {
        title: "내용",
        key: "content",
        type: "editor",
        required: true,
        readOnly: type === "PARTNER" || mode !== "create",
        onChange: (e) => {
          setContent(e?.target?.value);
        }
      },
    ]);
  }, [mode]);



  useEffect(() => {
    setValidateFields(fields);
    if (isAdmin()) {
      setMode(selectedItem ? "modify" : "create");
    } else {
      setMode(selectedItem ? type === "PARTNER" ? "view" : "detail" : "create");
    }
    let content = cloneDeep(selectedItem?.content);
    if (selectedItem) {

      if (!content.includes("{footer}")) {
        content = content.replace("{companyName}", convertData.companyName);
        content = content.replace("{ceoName}", convertData.ceoName);
        content = content.replace("{tel}", convertData.tel);
        content = content.replace("{address}", convertData.address);
        content = content.replace("{fax}", convertData.fax);
        content = content.replace("{homepage}", convertData.homePageUrl);
        content = content.replace("{blog}", convertData.blogUrl);
        content = content.replace("{instagram}", convertData.instagramUrl);
        content = content.replace("{youtube}", convertData.youtubeUrl);
      }

      if (convertData && content.includes("{footer}")) {
        const footer = footerType === "logo" ? mailFormSetLogo(convertData) : mailFormSetText(convertData);
        content = selectedItem.content.replace("{footer}", footer);
      }


      setForm({
        ...selectedItem,
        content,
        isHide: selectedItem.isHide + "",
      });
      setOriginForm({
        ...selectedItem,
        isHide: selectedItem.isHide + "",
      });
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);



  useEffect(() => {
    !isEmpty(content) && handleOnChange({ content });


  }, [content]);


  useEffect(() => {
    if (convertData && !isEmpty(form.content)) {
      const footer = footerType === "logo" ? mailFormSetLogo(convertData) : mailFormSetText(convertData);
      const newContent = originForm.content.replace("{footer}", footer);
      setForm({ ...form, content: newContent });
    }
  }, [footerType]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
      size="xxx-lg"
    >
      <div className="item-write">
        <ModalHeader>
          {selectedItem &&
            <>"{selectedItem.title}"
            </>} 뉴스레터 {mode === "create" ? "신규 등록" : "수정"}
        </ModalHeader>
        {/* <Form
          form={{ footerType }}
          fields={[{
            title: "푸터 타입",
            key: "footerType",
            type: "radio",
            required: true,
            options: {
              list: [{ label: "로고", value: "logo" }, { label: "텍스트", value: "text" }]
            }

          }]}
          onChange={(e) => {
            const { name, value } = e.target;
            name === "footerType" && setFooterType(value);
          }}
        /> */}

        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === "create" ? "등록" : "수정"}
          submit={handleSubmit}
          cancel={cancel}
          cancelText={type === "YDS" ? "취소" : "닫기"}
          mode={mode}
        />
      </div>

    </Modal>
  );
};

export default MailForm;